export default function HoverFace() {
  return (
    <img
      src={process.env.PUBLIC_URL + "/images/03_Mala_srna_hover.jpg"}
      alt=""
    />
  );
}
